module.exports = "/assets/7b7f756ccfc96c8f13a3fae3ce382a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AB.png
// module id = 1189
// module chunks = 0